/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Category_Explore_NextInputs */

const en_directory_category_explore_next = /** @type {(inputs: Directory_Category_Explore_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore other categories`)
};

const zh_directory_category_explore_next = /** @type {(inputs: Directory_Category_Explore_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索其他分类`)
};

/**
* | output |
* | --- |
* | "Explore other categories" |
*
* @param {Directory_Category_Explore_NextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_category_explore_next = /** @type {((inputs?: Directory_Category_Explore_NextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Category_Explore_NextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_category_explore_next(inputs)
	return zh_directory_category_explore_next(inputs)
});
export { directory_category_explore_next as "directory.category.explore_next" }